import * as Sentry from '@sentry/react';

/**
 * Captura una excepción y la envía a Sentry
 * @param error - El error a capturar
 * @param context - Contexto adicional para el error
 */
export const captureException = (error: Error, context?: Record<string, any>) => {
  if (!error) return;

  Sentry.captureException(error, {
    tags: {
      feature: context?.feature || 'file_upload',
      ...context?.tags,
    },
    extra: {
      ...context,
    },
  });
};

/**
 * Captura un mensaje de warning y lo envía a Sentry
 * @param message - El mensaje a capturar
 * @param context - Contexto adicional
 */
export const captureWarning = (message: string, context?: Record<string, any>) => {
  Sentry.captureMessage(message, {
    level: 'warning',
    tags: {
      feature: context?.feature || 'file_upload',
      ...context?.tags,
    },
    extra: {
      ...context,
    },
  });
};

/**
 * Agrega un breadcrumb para tracking de eventos
 * @param message - Mensaje del breadcrumb
 * @param category - Categoría del evento
 * @param level - Nivel de severidad
 * @param data - Datos adicionales
 */
export const addBreadcrumb = (
  message: string,
  category: string = 'file_upload',
  level: 'info' | 'warning' | 'error' = 'info',
  data?: Record<string, any>
) => {
  Sentry.addBreadcrumb({
    message,
    category,
    level,
    data,
  });
};

